import React from 'react';
import {WeaSearchGroup} from 'ecCom';
import {WeaLocaleProvider} from 'ecCom';
const getLabel = WeaLocaleProvider.getLabel;
import EType from './base/EType';
import ETitle from './base/ETitle';
import EShowNum from './base/EShowNum';
import ELinkMode from './base/ELinkMode';
//import EField from './base/EField';
import EScrollDirection from './base/EScrollDirection';
import ERemindMode from './base/ERemindMode';
import DataSourceTable from './base/DataSourceTable';

// 流程中心
class Content_8 extends React.Component {
    render() {
        const {hpid, eid, ebaseid, eShareLevel, synergyParams} = this.props;
        let __DataSourceTable = <div></div>;
        if (eShareLevel == '2') {
            __DataSourceTable = <DataSourceTable ref="dataSourceTable" hpid={hpid} eid={eid} ebaseid={ebaseid} {...this.props.eTabs} synergyParams={synergyParams}/>;
        }

        return (
            <div>
                <WeaSearchGroup title={getLabel(81711, '基本信息')} needTigger={true} showGroup={true}>
                    <EType ref="eType" value={this.props.eBaseName}/>
                    {this.props.eShareLevel == '2' ? <ETitle ref="eTitle" eid={this.props.eid} value={this.props.eTitle}/> : ''}
                    <EShowNum ref="eShowNum" value={this.props.eShowNum}/>
                    <ELinkMode ref="eLinkMode" options={this.props.eLinkMode.options} value={this.props.eLinkMode.selected}/>
                   {/* {this.props.eShareLevel == '2' ? <EScrollDirection ref="eScrollDirection" options={this.props.eScrollDirection.options} value={this.props.eScrollDirection.selected}/> : ''}*/}
                    <ERemindMode ref="eRemindMode" value={this.props.eRemindMode}/>
                </WeaSearchGroup>
                {__DataSourceTable}
            </div>
        );
    }

    getSaveValues() {
        return {
            eContentTitle: this.refs['eTitle'] ? this.refs['eTitle'].getSaveValues() : this.props.eTitle,
            eContentShowNum: this.refs['eShowNum'].getSaveValues(),
            eContentLinkMode: this.refs['eLinkMode'].getSaveValues(),
            eContentScrollDirection: this.refs['eScrollDirection'] ? this.refs['eScrollDirection'].getSaveValues() : this.props.eScrollDirection.selected,
            eContentRemindMode: this.refs['eRemindMode'].getSaveValues(),
            eContentTabWidth: {tabwidth: this.props.etabwidth, methodvalue: this.props.methodvalue},
            eTabs: this.refs['dataSourceTable'] ? this.refs['dataSourceTable'].getSaveValues() : {}
        };
    }
}

export default Content_8;



// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal/elements/components/common/setting_new/content/Content_8.js